export const DEVICEREPORT_SEARCH_INIT='device/date/SEARCH_INIT';
export const DEVICEREPORT_SEARCH_DATE='device/date/SEARCH_DATE';
export const DEVICEREPORT_SEARCH_TYPE='device/date/SEARCH_TYPE';
export const DEVICEREPORT_BMS_TYPE='device/date/BMS_TYPE';
